import styled from 'styled-components';
import { Orientation, Platform } from 'sofa-reborn-react';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

export const Div = styled.div<{
	orientation: Orientation;
	platform: Platform;
}>`
	* {
		touch-action: pan-y;
	}
	display: flex;
	height: 100%;
	overflow: hidden;
	touch-action: pan-y;
	flex-direction: ${(props) => (props.orientation === 'portrait' ? 'column' : 'row')};
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	margin: 0 auto;
	position: relative;
`;

export const FooterWrapper = styled.div`
	position: absolute;
	bottom: 0;
	width: 100%;
	border-bottom: 1px solid ${SkapaTheme.color.border.light};
`;
